import {apiAction} from './helper';

export const GET_REPORTS = apiAction('GET_REPORTS');
export const GET_REPORT = apiAction('GET_REPORT');
export const CREATE_REPORT = apiAction('CREATE_REPORT');
export const UPDATE_REPORT = apiAction('UPDATE_REPORT');
export const DELETE_REPORT = apiAction('DELETE_REPORT');
export const GET_REPORT_CONFIGURATIONS = apiAction('GET_REPORT_CONFIGURATIONS');
